export default __webpack_public_path__ + "static/media/newPromotionBanner.c620810b.svg";